import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase services
import {
  getHomePageData,
  updateHomePageData,
} from "../../lib/firebase/firestore";
import { HomePageData } from "../../types";

export const EditSettingsPage = () => {
    const navigate = useNavigate();
  const [formData, setFormData] = useState<HomePageData>({
    hero: {
      title: "",
      subtitle: "",
      backgroundImage: "",
    },
    featured: {
      title: "",
      description: "",
      image: "",
    },
  });

  const [loadingHero, setLoadingHero] = useState(false);
  const [loadingFeatured, setLoadingFeatured] = useState(false);

  // Load homepage data
  useEffect(() => {
    const loadSettings = async () => {
      const data = await getHomePageData();
      if (data) setFormData(data);
    };

    loadSettings();
  }, []);

  const handleChange = (
    section: keyof HomePageData,
    field: string,
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleSaveHero = async () => {
    setLoadingHero(true);
    try {
      await updateHomePageData(formData);
      alert("Hero updated successfully!");
    } catch (error) {
      console.error("Error updating hero:", error);
      alert("Failed to update hero");
    }
    setLoadingHero(false);
  };

  const handleSaveFeatured = async () => {
    setLoadingFeatured(true);
    try {
      await updateHomePageData(formData);
      alert("Featured project updated successfully!");
    } catch (error) {
      console.error("Error updating featured:", error);
      alert("Failed to update featured");
    }
    setLoadingFeatured(false);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Edit Homepage Settings</h2>

      {/* Hero Section */}
      <section
        style={{
          marginBottom: "3rem",
          borderBottom: "1px solid #ccc",
          paddingBottom: "2rem",
        }}
      >
        <h3>Hero Section</h3>
        <input
          placeholder="Title"
          value={formData.hero.title}
          onChange={(e) => handleChange("hero", "title", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <textarea
          placeholder="Subtitle"
          value={formData.hero.subtitle}
          onChange={(e) => handleChange("hero", "subtitle", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          placeholder="Hero Background Image URL"
          value={formData.hero.backgroundImage}
          onChange={(e) =>
            handleChange("hero", "backgroundImage", e.target.value)
          }
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <button
          type="button"
          onClick={handleSaveHero}
          disabled={loadingHero}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.5rem",
            cursor: "pointer",
            borderRadius: "9999px",
          }}
        >
          {loadingHero ? "Saving..." : "Save Hero"}
        </button>
      </section>

      {/* Featured Project Section */}
      <section style={{ marginBottom: "3rem" }}>
        <h3>Featured Project</h3>
        <input
          placeholder="Featured Title"
          value={formData.featured.title}
          onChange={(e) => handleChange("featured", "title", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <textarea
          placeholder="Featured Description"
          value={formData.featured.description}
          onChange={(e) =>
            handleChange("featured", "description", e.target.value)
          }
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          placeholder="Featured Image URL"
          value={formData.featured.image}
          onChange={(e) => handleChange("featured", "image", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <button
          type="button"
          onClick={handleSaveFeatured}
          disabled={loadingFeatured}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.5rem",
            cursor: "pointer",
            borderRadius: "9999px",
          }}
        >
          {loadingFeatured ? "Saving..." : "Save Featured Project"}
        </button>
      </section>
    </div>
  );
};
